export default __webpack_public_path__ + "static/media/img-0530-norway-premium-face.3db948a7.png";